import { SContainer } from '@avalara/skylab-sdk/react';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectState } from '../../../selectors';
import { setCurrentOfferPage } from '../../../store/offer';
import { Pages } from '../../../../shared/types/offers';
import ShopifySettingUp from './avalara-for-shopify';
import SettingUp from '../../shared/setting-up';
const SetUp = () => {
    const dispatch = useDispatch();
    const { offer: { offerFlow }, features, } = useSelector(selectState);
    useEffect(() => {
        dispatch(setCurrentOfferPage(Pages.SettingUp));
    }, []);
    const showShopifyConnector = features['AVALARA-FOR-SHOPIFY-FLOW'] ?
        React.createElement(ShopifySettingUp, null) : null;
    const getSetupComponentForOffer = () => {
        switch (offerFlow) {
            case 'avalara-for-shopify': return showShopifyConnector;
            default: return React.createElement(SettingUp, null);
        }
    };
    return (React.createElement(SContainer, { role: 'main' }, getSetupComponentForOffer()));
};
export default SetUp;
